import { Badge } from '@mantine/core';
import { FILEIMPORTKINDOPTIONS } from '@constants';

function KindBadge({ kind }: { kind?: string }) {
  const option =
    FILEIMPORTKINDOPTIONS.find((item) => item.value === kind) || FILEIMPORTKINDOPTIONS[0];
  return (
    <Badge color={option.value === 'export' ? 'grape' : 'gray'} variant="light">
      {option.label}
    </Badge>
  );
}

export default KindBadge;
